import React, { useState } from 'react';
import Text from '../../../BaseModule/Components/Text';
import RemoveConfirmationModal from '../../../BaseModule/Components/RemoveConfirmation/RemoveConfirmationModal';

interface Props {
	onConfirm: string;
}

const UserFamilyRemoveInvitation: React.FC<Props> = ({ onConfirm }) => {
	const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);

	const handleConfirm = async () => {
		// @ts-ignore
		window.location.href = onConfirm.replace(/^"(.*)"$/, '$1');
	};

	return (
		<>
			<div onClick={() => setIsConfirmationOpen(true)}>
				<Text
					className='btn btn-submit light'
					tx='base.familyMember.removeInvitation'
				/>
			</div>
			{isConfirmationOpen && (
				<RemoveConfirmationModal
					opened
					onClose={() => setIsConfirmationOpen(false)}
					onConfirm={handleConfirm}
					confirmationText='component.userFamilyRemoveInvitation.text'
					confirmationTitle='component.userFamilyRemoveInvitation.title'
				/>
			)}
		</>
	);
};

export default UserFamilyRemoveInvitation;
